// ตรวจจับว่าเป็น Facebook In-App Browser หรือไม่
export function isFacebookBrowser() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
}

// บังคับเปิดใน browser ภายนอก
export function openInExternalBrowser() {
  if (isFacebookBrowser()) {
    // สำหรับ Android
    const url = window.location.href;
    window.location.href = `intent://${url. replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com. android.chrome;end`;

    // สำหรับ iOS
    setTimeout(() => {
      window.location.href = url;
    }, 1000);
    
    // Fallback: แสดงข้อความให้ผู้ใช้เปิดเอง
    setTimeout(() => {
      alert('กรุณากดปุ่ม ⋮ แล้วเลือก "เปิดในเบราว์เซอร์" เพื่อเข้าสู่ระบบ');
    }, 2000);
  }
}